import React from 'react';
import { useIntl } from 'react-intl';
import VolumetricModularImg from '../images/light-gauge-steel.png';
import Icons from '../../../components/Icons/Icons';
import classNames from 'classnames';
import css from './Sections.module.css';

function SectionsLightGaugeSteel() {
  const intl = useIntl();

  return (
    <div className={classNames(css.fusionLogSections, css.lightGaugeSteelSections)}>
      <div className={css.fixedWidthContainer}>
        <h2>{intl.formatMessage({ id: 'SectionsLightGaugeSteel.title' })}</h2>
        <div className={css.volumetricModularContent}>
          <div className={css.volumetricModularInfo}>
            <p>{intl.formatMessage({ id: 'SectionsLightGaugeSteel.description1' })}</p>
            <p>{intl.formatMessage({ id: 'SectionsLightGaugeSteel.description2' })}</p>
          </div>
          <div className={css.volumetricModularImg}>
            <img src={VolumetricModularImg} alt="" />
          </div>
        </div>
        <div className={css.logPoints}>
          <ul>
            {['list1', 'list2', 'list3', 'list4'].map((key, i) => (
              <li key={i}>
                <Icons name="checkListIcon" />
                {intl.formatMessage({ id: `SectionsLightGaugeSteel.${key}` })}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default SectionsLightGaugeSteel;
